<template>
  <section class="singleWordDetailComponent">
    <div class="tit-bar">
      <h3 class="tit">{{ contType }}内容展示</h3>
      <el-button type="success" size="small" @click="appImgClick">查看App示例</el-button>
    </div>
    <div class="displayContent">
      <div class="cont">
        <div class="cell">
          <div class="name">{{ contType }}内容</div>
          <div class="value">{{ currentClickData.name }}</div>
        </div>
        <div class="cell">
          <div class="name">标准读音</div>
          <div class="value">读音文件</div>
        </div>
        <div class="cell">
          <div class="name">卡片图</div>
          <div class="value">
            <el-image :src="currentClickData.imgUrl" fit="fit">
              <div slot="error" class="image-slot">
                <i class="el-icon-picture-outline" />
              </div>
            </el-image>
            <!-- <el-image :src="currentClickData.imgUrl" fit="fit" /> -->
          </div>
        </div>
        <div v-if="contType !== '句型'" class="cell lastCell">
          <div class="name">口型图</div>
          <div class="value">
            <video class="video" :src="currentClickData.mouthShapePath" />
          </div>
        </div>
      </div>
    </div>

    <!-- app示例图 -->
    <GDialog :dialog.sync="appImgDialog" :show-footer="false" :append-to-body="true" width="40%" class="center-dialog">
      <img :src="appDemoUrl" style="max-width: 100%;margin-bottom: 20px;">
    </GDialog>
  </section>
</template>
<script>
import { mapState } from 'vuex'
export default {
  props: {
    activeTabsName: {
      type: String,
      default: 'first'
    }
  },
  data () {
    return {
      appImgDialog: {
        title: '查看App示例',
        visible: false
      }
    }
  },
  computed: {
    ...mapState('courseStep', ['currentClickData', 'courseData', 'stepOptions', 'stepActive', 'courseStepOptions']),
    // 当前 已选中类型 传参类型
    checkedTypeParams () {
      return this.courseStepOptions[this.courseData.curriculumType][this.stepOptions[this.stepActive].dicCode]
    },
    // 根据定义的配置文件，确定当前是属于单词类，还是 句型类  字母类
    contType () {
      let type = '单词'
      const activeTab = Number(this.activeTabsName)
      const item = this.checkedTypeParams.checkedType[activeTab]

      // 根据当前 tab激活状态，取数组的第几项
      if (item.basicMeans === 'WORD_MEANS') { // 单词
        type = '单词'
      } else if (item.basicMeans === 'SENTENCE_PATTERN_MEANS') { // 句型
        type = '句型'
      } else if (item.basicMeans === 'HIGH_FREQUENCY_MEANS') { // 高频词
        if (item.isRelation === '1') {
          type = '单词'
        } else {
          type = '句型'
        }
      } else if (item.basicMeans === 'NATURAL_SPELLING_MEANS') { // 自然拼读
        if (item.isRelation === '1') {
          type = '字母'
        } else {
          type = '单词'
        }
      } else if (item.basicMeans === 'SENTENCE_PATTERN_GROUP_MEANS') { // 句型组
        type = '句型'
      } else if (item.basicMeans === 'LETTER_MEANS') { // 字母
        type = '字母'
      } else if (item.basicMeans === 'VIDEO_MEANS') { // 视频
        type = '视频'
      }

      return type
    },
    appDemoUrl () {
      if (this.stepOptions[this.stepActive].dicCode === 'Lead-in') {
        return require('@assets/images/demo-leadIn.png')
      } else if (this.stepOptions[this.stepActive].dicCode === 'Highlights') {
        return require('@assets/images/demo-highlights.png')
      } else if (this.stepOptions[this.stepActive].dicCode === 'Story') {
        return require('@assets/images/demo-story.png')
      } else if (this.stepOptions[this.stepActive].dicCode === 'Speaking') {
        return require('@assets/images/demo-speaking.png')
      } else if (this.stepOptions[this.stepActive].dicCode === 'Quiz') {
        return require('@assets/images/game1.png')
      } else {
        return ''
      }
    }
  },
  created () {

  },
  methods: {
    appImgClick () {
      this.appImgDialog.visible = true
    }
  }
}
</script>

<style lang='scss'>
.singleWordDetailComponent{
  flex: 1;
  height: 250px;
  .tit-bar{
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 6px;
    color: #53402B;
  }
  .cont{
    display: flex;
    flex-wrap: wrap;
  }
  .displayContent{
    min-height: 500px;
    max-height: 500px;
    border: 1px solid #EEEEEE;
    border-radius: 8px;
    padding:24px;
  }
  .cell{
    width: calc(50% - 20px);
    margin-right: 20px;
    display: flex;
    margin-bottom: 34px;
    .name{
      color: #828481;
      margin-right: 20px;
      width: 80px;
      text-align: right;
      flex-shrink: 0;
    }
    .value{
      flex-grow: 1;
      .el-image{
        border: 1px solid #EEEEEE;
        border-radius: 8px;
        background-color: white;
        width: 163px;
        height: 153px;
      }
      .video{
        width: 254px;
        height: 153px;
        border: 1px solid #EEEEEE;
        border-radius: 8px;
        background-color: white;
      }
    }
  }

  @media screen and (max-width: 1681px) {
    .lastCell{width:100%}
  }

}
.center-dialog .el-dialog__body{
  text-align: center;
}
</style>
